import { type RefObject, useEffect } from "react";
import { logger } from "./logger";

function useOutsideClick(refs: (RefObject<Element | null> | Element | null)[], callback: () => void) {
   useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
         if (event.target === null) {
            return;
         }
         const clickOutside = refs.reduce((p: boolean, ref: RefObject<Element | null> | Element | null) => {
            if (ref instanceof Element) {
               const isOutside = p && !ref.contains(event.target as Element);
               logger.log("utils", "Checking outside click for ref:", ref, "isOutside:", isOutside, "event: ", event);
               return isOutside;
            }
            if (ref?.current) {
               return p && !ref.current.contains(event.target as Element);
            }
            return p;
         }, true);
         if (clickOutside) {
            callback();
         }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
         // Unbind the event listener on clean up
         document.removeEventListener("mousedown", handleClickOutside);
      };
   }, [refs]);
}

export default useOutsideClick;
